import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) {
        return null;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return value && emailRegex.test(value) ? null : { invalidEmail: true };
}

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) {
    return null; // let Validators.required handle empty case
  }

  try {
    // extract:false ensures invalid text containing a phone-like substring is rejected.
    const phoneNumber = parsePhoneNumberFromString(value, { extract: false });

    if (!phoneNumber) {
      return { invalidPhone: true };
    }

    const hasCountryCode = !!phoneNumber.countryCallingCode;
    const nationalNumber = phoneNumber.nationalNumber;
    const hasTenDigitNationalNumber =
      nationalNumber?.length === 10;
    const valid = phoneNumber.isValid();
    return hasCountryCode && hasTenDigitNationalNumber && valid
      ? null
      : { invalidPhone: true };

  } catch {
    return { invalidPhone: true };
  }
}
